import apiClient from './apiClient';
import type { ApiResponse } from '../types/common';
import type { NivelDeAplicacao } from '../types/nivelDeAplicacao';
import type { ExposureLevel, RiskApplicationReportRow } from '../types/riskApplication';
import type { DestinoEfetivo, IdDoBanco } from './efetivosService';

/**
 * Uma aplicação do risco, com o destino já resolvido (nível, nome e empresa). O servidor só
 * devolve as de empresas que a pessoa enxerga (#606, E3).
 */
export interface AplicacaoDoRisco {
  id: IdDoBanco;
  riskId: IdDoBanco;
  scope: NivelDeAplicacao;
  scopeId: IdDoBanco;
  exposureLevel: ExposureLevel | null;
  reportTypes: RiskApplicationReportRow[];
  /** Funcionários que o destino alcança. */
  alcance: { funcionarios: number };
  destino: DestinoEfetivo;
}

/** As aplicações e o resumo delas; quem duas aplicações cobrem conta uma vez só. */
export interface OndeORiscoEstaAplicado {
  aplicacoes: AplicacaoDoRisco[];
  resumo: { empresas: number; funcionariosExpostos: number };
}

export async function buscarOndeORiscoEstaAplicado(riskId: IdDoBanco): Promise<OndeORiscoEstaAplicado> {
  const resposta: ApiResponse<OndeORiscoEstaAplicado> = await apiClient.get<OndeORiscoEstaAplicado>(
    `/risk-applications/por-risco/${encodeURIComponent(String(riskId))}`
  );
  return resposta.data ?? { aplicacoes: [], resumo: { empresas: 0, funcionariosExpostos: 0 } };
}
